
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import CustomDatePicker from '@/components/search/CustomDatePicker.vue';

  export default defineComponent({
    name: 'trades-summary-widget',
    props: {
      widgetClasses: String,
    },
    components: {
      CustomDatePicker,
    },
    async setup() {
      const { t, te } = useI18n();
      const loading = ref(false);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const selectedPeriod = ref('last-7-days');
      const customDateFrom = ref('');
      const customDateTo = ref('');
      const showDatePicker = ref(false);

      const adminTrades = ref<{ total?: number; percentage?: number }>({});
      const mojTrades = ref<{ total?: number; percentage?: number }>({});

      const store = useStore();
      await store.dispatch(Actions.GET_TRADES_SUMMARY_DASHBOARD);
      const data = computed(() => store.getters.tradesSummaryDashboard);

      // Initialize data
      if (data.value && data.value.data && Array.isArray(data.value.data)) {
        const adminData = data.value.data.find((item) => item.type === 'admin');
        const mojData = data.value.data.find((item) => item.type === 'moj');

        adminTrades.value.total = adminData?.count ?? 0;
        adminTrades.value.percentage = adminData?.countPercentage ?? 0;
        mojTrades.value.total = mojData?.count ?? 0;
        mojTrades.value.percentage = mojData?.countPercentage ?? 0;
      }

      const showCustomDatePicker = () => {
        showDatePicker.value = true;
        selectedPeriod.value = 'custom';
      };

      const applyCustomDates = async () => {
        if (!customDateFrom.value || !customDateTo.value) {
          alert('Please select both dates');
          return;
        }
        showDatePicker.value = false;
        await selectPeriod('custom');
      };

      const selectPeriod = async (period: string) => {
        loading.value = true;
        selectedPeriod.value = period;
        try {
          const obj = {
            dateRange: period,
            showTrend: true,
            dateFrom: '',
            dateTo: '',
          };

          if (
            period === 'custom' &&
            customDateFrom.value &&
            customDateTo.value
          ) {
            obj.dateFrom = customDateFrom.value;
            obj.dateTo = customDateTo.value;
          }

          await store.dispatch(Actions.GET_TRADES_SUMMARY_DASHBOARD, obj);
          const payload = store.getters.tradesSummaryDashboard;

          if (payload?.data && Array.isArray(payload.data)) {
            const adminData = payload.data.find(
              (item) => item.type === 'admin'
            );
            const mojData = payload.data.find((item) => item.type === 'moj');

            adminTrades.value.total = adminData?.count ?? 0;
            adminTrades.value.percentage = adminData?.countPercentage ?? 0;
            mojTrades.value.total = mojData?.count ?? 0;
            mojTrades.value.percentage = mojData?.countPercentage ?? 0;
          }
        } finally {
          loading.value = false;
        }
      };

      const getTextColor = (percentage: number | undefined) => {
        if (!percentage) return '#6c757d';
        if (percentage > 0) return '#28a745';
        if (percentage < 0) return '#dc3545';
        return '#6c757d';
      };

      const getArrowSrc = (percentage: number | undefined) => {
        if (!percentage) return '';
        if (percentage > 0) return '/media/icons/dash/up.png';
        if (percentage < 0) return '/media/icons/dash/down.png';
        return '';
      };

      return {
        adminTrades,
        mojTrades,
        data,
        loading,
        selectedPeriod,
        selectPeriod,
        translate,
        showDatePicker,
        customDateFrom,
        customDateTo,
        showCustomDatePicker,
        applyCustomDates,
        getTextColor,
        getArrowSrc,
      };
    },
  });
